module.exports = __webpack_public_path__ + "media/images/pages/home_featured/who-we-are-banner-0c7bd48d9ed10bb78e6d58e3a24c546d.png";